import React from 'react';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {IconButton} from '@mui/material';
import './NavBefore.scss';

const NavBefore = ({event}) => {
  return (
    <IconButton component="span" onClick={event} >
      <NavigateBeforeIcon className='ib-nb'/>
    </IconButton>
  );
};

export default NavBefore;
